var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "BuildABox" },
    [
      _c("img", {
        attrs: {
          src:
            "https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=ea9067b2-6212-4216-9be0-b7a1465c320d",
          width: "1",
          height: "1",
          border: "0"
        }
      }),
      _vm._v(" "),
      _vm.currentPage == 0
        ? _c("Page1", {
            on: {
              changepage: function($event) {
                return _vm.changePage($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "build-wrapper" },
        [
          _c("div", { staticClass: "builder-content-wrapper" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentPage > 0,
                    expression: "currentPage > 0"
                  }
                ],
                staticClass: "builder-experience-container no-scrollbar",
                attrs: { id: "scroll-container" }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentStep > 1,
                        expression: "currentStep > 1"
                      }
                    ],
                    staticClass: "full-view-header",
                    class: _vm.currentStep == 1 ? "step2" : "",
                    attrs: { id: "scroll-header" }
                  },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.changePage(false)
                            }
                          }
                        },
                        [_vm._v("< back")]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button white border filters",
                        class: [
                          !_vm.selectedCardsOccasions.includes("View All")
                            ? "selected"
                            : "",
                          _vm.currentStep > 2 ? "card" : ""
                        ],
                        on: {
                          click: function() {
                            _vm.$refs.cardComponent.showFilters()
                          }
                        }
                      },
                      [
                        !_vm.selectedCardsOccasions.includes("View All")
                          ? _c("img", {
                              staticClass: "purple",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                              }
                            })
                          : _c("img", {
                              staticClass: "normal",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
                              }
                            }),
                        _vm._v("\n            Filters \n            "),
                        !_vm.selectedCardsOccasions.includes("View All")
                          ? _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.selectedCardsOccasions.length) +
                                  ")"
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "steps" }, [
                      _vm._v(
                        "\n            STEP " +
                          _vm._s(_vm.currentStep) +
                          " OF 3"
                      ),
                      _c("span", { staticClass: "dots" }, [_vm._v(":")]),
                      _c("span", { staticClass: "legend" }, [
                        _vm._v(_vm._s(_vm.currentCopy))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dot",
                          class: _vm.currentStep == 1 ? "current" : ""
                        },
                        [
                          _c("span", {
                            class: 1 <= _vm.currentStep ? "selected" : ""
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dot",
                          class: _vm.currentStep == 2 ? "current" : ""
                        },
                        [
                          _c("span", {
                            class: 2 <= _vm.currentStep ? "selected" : ""
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dot",
                          class: _vm.currentStep == 3 ? "current" : ""
                        },
                        [
                          _c("span", {
                            class: 3 <= _vm.currentStep ? "selected" : ""
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value:
                              "Save your selections for 24 hours. Inventory subject to availability",
                            expression:
                              "'Save your selections for 24 hours. Inventory subject to availability'"
                          }
                        ],
                        staticClass: "leave-builder",
                        on: { click: _vm.leaveBuilder }
                      },
                      [
                        _vm._v(_vm._s(_vm.headerText) + " "),
                        _c("img", {
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart.svg?v=1722005665",
                            alt: "save cart"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.currentPage == 1
                  ? _c("Page3", {
                      on: {
                        leavebuilder: _vm.leaveBuilder,
                        changepage: function($event) {
                          return _vm.changePage($event)
                        },
                        gostep: function($event) {
                          return _vm.goStep($event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentPage == 2
                  ? _c("Page4", {
                      on: {
                        changepage: function($event) {
                          return _vm.changePage($event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentPage > 2
                  ? _c("Page5", {
                      ref: "cardComponent",
                      attrs: { currentPage: _vm.currentPage },
                      on: {
                        changepage: function($event) {
                          return _vm.changePage($event)
                        },
                        gotoaddonselection: _vm.goToAddonSelection,
                        opencart: function($event) {
                          return _vm.openCart()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("SideCartNew", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentStep > 1,
                expression: "currentStep > 1"
              }
            ],
            ref: "outSideCart",
            attrs: {
              isSticking: _vm.isSticking,
              step: _vm.currentStep,
              fromCard: _vm.fromCard
            },
            on: {
              changepage: function($event) {
                return _vm.changePage($event)
              },
              bundle: function($event) {
                return _vm.bundle($event)
              },
              gostep: function($event) {
                return _vm.goStep($event)
              },
              cardwarning: function($event) {
                return _vm.cardWarning($event)
              }
            }
          }),
          _vm._v(" "),
          _vm.selectedAddonProducts.length > 0
            ? _c("SideCartMobile", {
                attrs: { step: _vm.currentStep },
                on: {
                  changepage: function($event) {
                    return _vm.changePage($event)
                  },
                  bundle: _vm.bundle
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.oosIsActive
        ? _c("OOSPopUp", {
            attrs: {
              oosProducts: _vm.noStockItems,
              firstStateProducts: _vm.currentStateSelectedAddons,
              fromSavedCart: _vm.fromSavedCart,
              fromCurated: _vm.fromCurated
            },
            on: {
              goback: _vm.closeOOSPopUp,
              continuesaved: _vm.continueSaved,
              continuecurated: _vm.continueCurated
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }